import isHtml from 'is-html';

export const asyncTimeout = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const isHTML = (value: any) => {
  return (typeof value === "string") ? isHtml(value) : false;
};
